import PubSub from "underpub-js";

var MenuItemSecondary = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

MenuItemSecondary.prototype.init = function(){

  var self = this;

  self.isLanguageButton = self.options.$el.hasClass("select-location");

  self.isLanguageButton && self.initLanguageButton();

};

MenuItemSecondary.prototype.initLanguageButton = function () {
  const self = this;

  self.options.$el.on("click", function () {
  	PubSub.publish("showLanguageSelectorModal")
  });
}

export default MenuItemSecondary;
